module.exports = __webpack_public_path__ + "img/Anjing&Berdiri.8c12c9e7.svg";